module.exports = __webpack_public_path__ + "img/tema-3-17.75cdd592.png";